'use client'

import Link from 'next/link'
import { industryOptions, KTechPioneersList } from '../_data/ktechpioneers'
import styles from '../ktechpioneers.module.scss'

const hexToRgba = (hex: string, alpha: number) => {
  const r = parseInt(hex.slice(1, 3), 16)
  const g = parseInt(hex.slice(3, 5), 16)
  const b = parseInt(hex.slice(5, 7), 16)
  return `rgba(${r},${g},${b},${alpha})`
}

export const IndustryBadge = ({ type }: { type: string }) => {
  const option = industryOptions.find(o => o.value === type)
  if (!option) return null
  return (
    <div
      className="inline-flex h-5 items-center justify-center rounded px-2"
      style={{ backgroundColor: hexToRgba(option.color, 0.25) }}>
      <span className="text-xs font-semibold text-white/80">
        {option.label}
      </span>
    </div>
  )
}

export const IndustryBadges = ({ types }: { types: string[] }) => (
  <div className="flex flex-wrap gap-1">
    {types.map(type => (
      <IndustryBadge key={type} type={type} />
    ))}
  </div>
)

export const ChallengeCard = ({
  item,
  compact = false,
}: {
  item: (typeof KTechPioneersList)[number]
  compact?: boolean
}) => (
  <Link
    href={item.url}
    className={`${styles.HoverImgScale} w-full group flex cursor-pointer flex-col overflow-hidden rounded-lg border border-[#2A2D32] bg-[rgba(20,22,24,0.2)] transition-all duration-300 hover:bg-[rgba(255,255,255,0.05)]
    ${compact ? '' : 'w-full tb:w-[calc(50%-8px)] pc:w-[calc(33.333%-10.7px)]'}`}>
    <div className={`relative aspect-[434/245] w-full overflow-hidden bg-black
    ${compact ? 'max-h-[214px]' : ''}`}>
      <img
        src={item.thumbnail}
        alt={item.company}
        className="absolute inset-0 h-full w-full object-cover"
      />
    </div>
    <div className="flex flex-col items-start justify-center flex-1 gap-2 p-4">
      <div
        className={`${compact ? `${styles.small_badge}` : 'flex-1'}`}>
        <IndustryBadges types={item.type} />
      </div>
      <div className="flex w-full flex-col gap-1 pc:gap-1.5">
        <h6
          className={`font-semibold text-[#f0f1f3] line-clamp-1 ${compact ? 'text-base' : 'text-base pc:text-xl'
            }`}>
          {item.company}
        </h6>
        <p
          className={`leading-snug break-all text-[#f0f1f3] ${compact ? 'text-sm line-clamp-2 h-[38.5px]' : 'text-sm line-clamp-2 pc:h-[38.5px]'
            }`}>
          {item.title}
        </p>
      </div>
    </div>
  </Link>
)
